export default __webpack_public_path__ + "static/media/SFProText-Semibold-1.fee27977.ttf";